import { logger } from "@/utils/logger";

/*export function buildHistoriesStepWithDetails(
    historiesStep: any[] = [],
    detailList: any[] = []
): any[] {
    logger.debug("test")
    if (!Array.isArray(historiesStep) || !historiesStep.length) {
        return [];
    }

    if (!Array.isArray(detailList) || !detailList.length) {
        return historiesStep.map((step: any) => ({
            ...step,
            histories: Array.isArray(step.histories) ? step.histories : [],
        }));
    }

    const filteredDetails = detailList
        .filter((item: any) => item?.businessData && item.businessData.currentAction)
        .sort((a: any, b: any) => {
            const dateA = new Date((a.creationDate || "").replace(" ", "T")).getTime();
            const dateB = new Date((b.creationDate || "").replace(" ", "T")).getTime();
            return dateB - dateA;
        });

    const groups: Array<{ currentAction: string; items: any[] }> = [];

    for (const detail of filteredDetails) {
        const currentAction = detail.businessData.currentAction;
        const lastGroup = groups[groups.length - 1];

        if (!lastGroup || lastGroup.currentAction !== currentAction) {
            groups.push({
                currentAction,
                items: [detail],
            });
        } else {
            lastGroup.items.push(detail);
        }
    }

    let groupIndex = 0;
    logger.debug("steps", historiesStep.map(s => s.taskDefinition));
logger.debug("details actions", detailList.map(d => d?.businessData?.currentAction));
logger.debug("filteredDetails length", filteredDetails.length);
logger.debug("groups", groups.map(g => g.currentAction));

    return historiesStep.map((step: any) => {
        let histories: any[] = [];
logger.debug("matching step", step.taskDefinition, "from groupIndex", groupIndex);
        while (groupIndex < groups.length) {
            const group = groups[groupIndex];

            if (group.currentAction === step.taskDefinition) {
                histories = group.items;
                groupIndex++;
                break;
            }

            groupIndex++;
        }

        return {
            ...step,
            histories,
        };
    });
}*/
export function buildHistoriesStepWithDetails(
    historiesStep: any[] = [],
    detailList: any[] = []
): any[] {
    if (!Array.isArray(historiesStep) || !historiesStep.length) {
        return [];
    }

    if (!Array.isArray(detailList) || !detailList.length) {
        return historiesStep.map((step: any) => ({
            ...step,
            histories: Array.isArray(step.histories) ? step.histories : [],
        }));
    }

    const sortByCreationDesc = (a: any, b: any) => {
        const dateA = new Date((a.creationDate || "").replace(" ", "T")).getTime();
        const dateB = new Date((b.creationDate || "").replace(" ", "T")).getTime();
        return dateB - dateA;
    };

    const hasStepTaskId = historiesStep.some(
        (s: any) => s?.taskId != null && String(s.taskId).length > 0
    );
    const hasDetailTaskId = detailList.some(
        (d: any) => d?.businessData?.taskId != null && String(d.businessData.taskId).length > 0
    );
    const useTaskId = hasStepTaskId && hasDetailTaskId;

    if (useTaskId) {
    const filteredDetails = detailList
        .filter(
            (item: any) =>
                item?.businessData?.taskId || item?.businessData?.currentAction
        )
        .sort(sortByCreationDesc);
    const compositeKey = (taskId: unknown, action: unknown) => {
        const tid =
            taskId != null && String(taskId).trim() !== ""
                ? String(taskId)
                : "__no_task__";
        const act =
            action != null && String(action).trim() !== ""
                ? String(action)
                : "__no_action__";
        return `${tid}::${act}`;
    };
    const byTaskAndAction = new Map<string, any[]>();
    const byActionOnly = new Map<string, any[]>();
    for (const detail of filteredDetails) {
        const bd = detail.businessData;
        const hasTaskId =
            bd?.taskId != null && String(bd.taskId).trim() !== "";
        if (hasTaskId) {
            const key = compositeKey(bd.taskId, bd.currentAction);
            if (!byTaskAndAction.has(key)) byTaskAndAction.set(key, []);
            byTaskAndAction.get(key)!.push(detail);
        } else if (bd?.currentAction) {
            const key = String(bd.currentAction);
            if (!byActionOnly.has(key)) byActionOnly.set(key, []);
            byActionOnly.get(key)!.push(detail);
        }
    }
    return historiesStep.map((step: any) => {
        const withTaskId =
            byTaskAndAction.get(
                compositeKey(step?.taskId, step?.taskDefinition)
            ) || [];
        const actionOnly =
            byActionOnly.get(String(step?.taskDefinition)) || [];
        // fusion + tri si tu veux garder l'ordre chronologique global
        const histories = [...withTaskId, ...actionOnly].sort(
            sortByCreationDesc
        );
        return { ...step, histories };
    });
}

    const filteredDetails = detailList
        .filter((item: any) => item?.businessData?.currentAction)
        .sort(sortByCreationDesc);

    const map = new Map<string, any[]>();
    for (const detail of filteredDetails) {
        const key = detail.businessData.currentAction;
        if (!map.has(key)) map.set(key, []);
        map.get(key)!.push(detail);
    }

    return historiesStep.map((step: any) => ({
        ...step,
        histories: map.get(step.taskDefinition) || [],
    }));
}
export function hasFilledHistories(historiesStep: any[] = []): boolean {
    return historiesStep.some(
        (step: any) => Array.isArray(step.histories) && step.histories.length > 0
    );
}

export function enrichHistoriesStepWithOfferDetails(
    historiesStep: any[] = [],
    detailList: any[] = []
): any[] {
    if (!historiesStep.length || !detailList.length) {
        return historiesStep;
    }

    if (hasFilledHistories(historiesStep)) {
        return historiesStep;
    }

    const enriched = buildHistoriesStepWithDetails(historiesStep, detailList);
    return hasFilledHistories(enriched) ? enriched : historiesStep;
}